/* tslint:disable */
/* eslint-disable */

import { ReaderFragment } from "relay-runtime";
import { FragmentRefs } from "relay-runtime";
export type Footer_viewer = {
    readonly isTradeExperienceEnabled: boolean | null;
    readonly isSellerDirectoryEnabled: boolean | null;
    readonly isSellerApplicationEnabled: boolean | null;
    readonly isAboutUsPageEnabled: boolean | null;
    readonly isCareersPageEnabled: boolean | null;
    readonly isPressPageEnabled: boolean | null;
    readonly isQuestionsPageEnabled: boolean | null;
    readonly isSiteMapsEnabled: boolean | null;
    readonly disableFooterSubscribe: boolean | null;
    readonly " $fragmentRefs": FragmentRefs<"CurrencySelector_viewer" | "FooterBottomRow_viewer" | "SocialLinkRow_viewer" | "FooterSubscribe_viewer">;
    readonly " $refType": "Footer_viewer";
};
export type Footer_viewer$data = Footer_viewer;
export type Footer_viewer$key = {
    readonly " $data"?: Footer_viewer$data;
    readonly " $fragmentRefs": FragmentRefs<"Footer_viewer">;
};



const node: ReaderFragment = {
  "kind": "Fragment",
  "name": "Footer_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "isTradeExperienceEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "TRADE_EXPERIENCE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"TRADE_EXPERIENCE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSellerDirectoryEnabled",
      "name": "featureFlag",
      "args": [
        {
          "kind": "Literal",
          "name": "feature",
          "value": "sellerDirectory"
        }
      ],
      "storageKey": "featureFlag(feature:\"sellerDirectory\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSellerApplicationEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "SELLER_APPLICATION"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"SELLER_APPLICATION\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isAboutUsPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "ABOUT_US_PAGE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"ABOUT_US_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isCareersPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "CAREERS_PAGE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"CAREERS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isPressPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "PRESS_PAGE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"PRESS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isQuestionsPageEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "QUESTIONS_PAGE"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"QUESTIONS_PAGE\")"
    },
    {
      "kind": "ScalarField",
      "alias": "isSiteMapsEnabled",
      "name": "isEnabledByLocale",
      "args": [
        {
          "kind": "Literal",
          "name": "featureName",
          "value": "HTML_SITE_MAPS"
        }
      ],
      "storageKey": "isEnabledByLocale(featureName:\"HTML_SITE_MAPS\")"
    },
    {
      "kind": "ScalarField",
      "alias": "disableFooterSubscribe",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "disableFooterSubscribe"
        }
      ],
      "storageKey": "isEnabled(key:\"disableFooterSubscribe\")"
    },
    {
      "kind": "FragmentSpread",
      "name": "CurrencySelector_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterBottomRow_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "SocialLinkRow_viewer",
      "args": null
    },
    {
      "kind": "FragmentSpread",
      "name": "FooterSubscribe_viewer",
      "args": null
    }
  ]
};
(node as any).hash = '6a9b7e61e2b7e6ea7187aa871f786bfa';
export default node;
